module.exports = __webpack_public_path__ + "assets/img/fire-attack.09436a4d.png";